import {ReactComponent as Icon} from '@image/icon_gps.svg';

const IconGps = () => {
    return   <Icon />;
};

export default IconGps;